import { getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import { fieldAddProductVulcan, fieldNewOrExistingCustomer, fieldProductVulcan } from '../../../utils/constant';
import { getFieldValue } from '../../utils';

const filterProduct = ({ fieldName, formFields: rawFormFields, orderData }) => {
  const locale = getLocale();
  const formFields = rawFormFields;
  const {
    vulcanWebform: {
      vulFibreInternet,
      vulCopperInternet,
      vulInternetBackup,
      vulBusinessWifi,
      vulTSB,
      vulBusinessOptikTV,
      vulOfficePhone,
      vulExistingCustomer,
      vulHSIA
    }
  } = locale === 'en-US' ? EN : FR;
  let filteredOptions = [];
  let update = false;
  const showProduct = [vulBusinessWifi, vulFibreInternet, vulInternetBackup];
  const productsThatHideBackup = [
    vulTSB,
    vulCopperInternet,
    vulBusinessOptikTV,
    vulOfficePhone
  ];

  if (fieldName === fieldAddProductVulcan) {
    const newOrExistingCustomerValue = getFieldValue(fieldNewOrExistingCustomer, formFields);
    const productVulcanValue = getFieldValue(fieldProductVulcan, formFields);
    const addProductVulcanValue = formFields[fieldAddProductVulcan].value || [];
    const isExistingCustomer = newOrExistingCustomerValue === vulExistingCustomer;
    const isHSIASelected =
      Array.isArray(productVulcanValue) && productVulcanValue.includes(vulHSIA);
    // For New customers, Internet Backup is offered alongside an internet product
    const hasCopperOrFibreInternet =
      addProductVulcanValue.includes(vulCopperInternet) ||
      addProductVulcanValue.includes(vulFibreInternet);

    // Internet Backup visibility:
    //  - Existing customer: show ONLY when HSIA is selected (SOF-3388)
    //  - New / unset customer: show ONLY when Copper or Fibre Internet is selected
    const shouldShowInternetBackup = isExistingCustomer
      ? isHSIASelected
      : hasCopperOrFibreInternet;

    // For New customers Internet Backup can pair with Copper Internet, so keep Copper
    // visible when Backup is selected and don't let Copper hide Backup.
    const backupCompatibleProducts = isExistingCustomer
      ? showProduct
      : [...showProduct, vulCopperInternet];
    const productsThatHideBackupForCustomer = isExistingCustomer
      ? productsThatHideBackup
      : productsThatHideBackup.filter(product => product !== vulCopperInternet);

    if (
      formFields[fieldAddProductVulcan].value &&
      !orderData.isThisVulcanOrder
    ) {
      filteredOptions = formFields[fieldAddProductVulcan].options;

      if (formFields[fieldAddProductVulcan].value.includes(vulInternetBackup)) {
        formFields[fieldAddProductVulcan].value = formFields[
          fieldAddProductVulcan
        ].value.filter(val => backupCompatibleProducts.includes(val));

        filteredOptions = filteredOptions.filter(option =>
          backupCompatibleProducts.includes(option.fields.value)
        );
        update = true;
      }

      if (formFields[fieldAddProductVulcan].value.includes(vulCopperInternet)) {
        filteredOptions = filteredOptions.filter(
          option => option.fields.value !== vulFibreInternet
        );
        update = true;
      }
      if (formFields[fieldAddProductVulcan].value.includes(vulFibreInternet)) {
        filteredOptions = filteredOptions.filter(
          option => option.fields.value !== vulCopperInternet
        );
        update = true;
      }

      // If any of the products that hide backup is selected, then remove backup from the options and value
      const hasProductThatHidesBackup = productsThatHideBackupForCustomer.some(
        product => formFields[fieldAddProductVulcan].value.includes(product)
      );
      if (hasProductThatHidesBackup) {
        formFields[fieldAddProductVulcan].value = formFields[
          fieldAddProductVulcan
        ].value.filter(val => val !== vulInternetBackup);
        filteredOptions = filteredOptions.filter(
          option => option.fields.value !== vulInternetBackup
        );
        update = true;
      }
    }

    // Hide Internet Backup whenever it should not be shown for the current customer type.
    // Existing: only with HSIA. New/unset: only with Copper or Fibre Internet selected.
    // Runs always (even when no value selected yet) to hide the option before first interaction.
    if (!orderData.isThisVulcanOrder && !shouldShowInternetBackup) {
      // Use selection-filtered options if value-guard already ran; otherwise use stable base options
      const optionsBase = update
        ? filteredOptions
        : formFields[fieldAddProductVulcan].options || [];
      filteredOptions = optionsBase.filter(
        option => option.fields.value !== vulInternetBackup
      );
      // Clear previously selected value to prevent hidden data submission (FR-005)
      if (
        formFields[fieldAddProductVulcan].value &&
        formFields[fieldAddProductVulcan].value.includes(vulInternetBackup)
      ) {
        formFields[fieldAddProductVulcan].value = formFields[
          fieldAddProductVulcan
        ].value.filter(v => v !== vulInternetBackup);
      }
      update = true;
    }
  }

  return { filteredOptions, update };
};

export default filterProduct;
